module.exports = {
      id: "charge-hight-usage",
      viewBox: "0 0 17 12",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#charge-hight-usage",
      toString: function () {
        return this.url;
      }
    }